<template>
  <zm-modal
    :title="title"
    :size="size"
    :visible="visible"
    :footer="false"
    @cancel="cancel">
    <div slot="modalBody">
      <div class="zm-form">
        <a-form :form="form" @submit="handleSubmit">
          <div class="subtitle">
            <div class="formTitle"></div>
            <div class="formTitleText">收款详情</div>
          </div>
          <a-row>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称" hasFeedback>
                <a-select
                  @change="contractChange"
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择销售合同"
                  v-decorator="['contractId', { rules: [{ required: true, message: '请选择销售合同！' }] }]"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in contractList" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
                <a-input
                  placeholder="自动导入合同金额"
                  addon-after="元"
                  disabled
                  autocomplete="off"
                  v-decorator="['contractMoney', { rules: [{ required: false, message: '自动导入合同金额！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人" hasFeedback>
                <a-select
                  @change="operatorIdChange"
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择经办人"
                  v-decorator="['operatorId', { rules: [{ required: true, message: '请选择经办人！' }] }]"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in operatorList" :key="index">
                    {{ item.userName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收款类型" hasFeedback>
                <a-select
                  filterable
                  :disabled="!isEdit"
                  placeholder="请选择收款类型"
                  v-decorator="['payType', { rules: [{ required: true, message: '请选择收款类型！' }] }]"
                >
                  <a-select-option :value="item.paymentType" v-for="(item, index) in paymentTypeList" :key="index">
                    {{ item.paymentDesc }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款公司" hasFeedback>
                <a-input
                  placeholder="自动导入付款公司"
                  disabled
                  autocomplete="off"
                  v-decorator="['companyName', { rules: [{ required: true, message: '自动导入付款公司！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收款金额">
                <a-input
                  placeholder="请输入收款金额"
                  autoComplete="off"
                  addon-after="元"
                  :disabled="!isEdit"
                  v-decorator="['payMoney', { rules: [{ required: true, message: '请输入收款金额！' }] }]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收款日期">
                <a-date-picker
                  style="width: 100%"
                  placeholder="请选择收款日期"
                  :disabled="!isEdit"
                  format="YYYY-MM-DD"
                  v-decorator="['payTime', { rules: [{ required: true, message: '请选择收款日期！' }] }]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <div class="subtitle">
              <div class="formTitle"></div>
              <div class="formTitleText">关联发票信息</div>
            </div>
            <a-col :span="24">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="已开票">
                <a-switch :disabled="!isEdit" @change="changePayState" valuePropName="checked" v-decorator="['invoiceState', { rules: [{ required: true, message: '请选择是否已开票！' }],initialValue: true,valuePropName: 'checked' }]" />
                <span style="display: inline-block;margin-left: 10px;font-size: 14px" v-if="invoiceState">是</span>
                <span style="display: inline-block;margin-left: 10px;font-size: 14px" v-else>否</span>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="invoiceShow">
              <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="关联开票" hasFeedback>
                <a-select
                  filterable
                  :disabled="!isEdit"
                  mode="multiple"
                  placeholder="请选择开票编号及金额"
                  v-decorator="['paymentInvoiceList', { rules: [{ required: true, message: '请选择开票编号及金额！' }] }]"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in invoiceList" :key="index">
                    {{ item.invoiceNo }}/{{ item.invoiceMoney }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <div style="text-align:right">
                <a-button
                  type="primary"
                  html-type="submit"
                  style="margin-right:10px;"
                  v-if="this.type !== this.$sysInfo.MODAL_VIEW"
                >
                  保存
                </a-button>
                <a-button @click="cancel">取消</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
  </zm-modal>
</template>

<script>
import moment from 'moment'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import {
  getHandlerList,
  controlCollection,
  getControlCollectionDetail
} from '@/api/business/collection'
import { getInvoiceList, getContractsSellPercentage } from '@/api/business/invoice'

export default {
  name: 'EditProprietors',
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    checkAble () {
      if (this.isEdit && this.able) {
        return false
      } else {
        return true
      }
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      size: 'large',
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      form: this.$form.createForm(this, { name: 'proprietors' }),
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      able: false,
      contractDetail: {},
      // 收款类型下拉数据
      paymentTypeList: [],
      // 销售合同下拉数据
      contractList: [],
      // 经办人下拉数据
      operatorList: [],
      // 关联开票下拉数据
      invoiceList: [],
      // 是否已开票
      invoiceState: true,
      // 关联开票是否显示
      invoiceShow: true,
      // 合同名称
      contractName: '',
      // 付款公司id
      companyId: '',
      // 经办人姓名
      operatorName: ''
    }
  },
  mounted () {
    // 获取下拉列表数据
    this.getDropdownListData()
  },
  methods: {
    // 设置类型insta
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
      if (this.model) {
        this.downloadZipShow = true
      } else {
        this.downloadZipShow = false
      }
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      if (flag) {
        if (this.type !== this.$sysInfo.MODAL_ADD) {
          this.getModelInfo()
        } else {
          this.$nextTick(() => {
            this.form.setFieldsValue({
              payTime: this.getToday()
            })
          })
        }
      }
      this.visible = flag
    },
    // 获取当天日期
    getToday () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return `${year}-${month}-${day}`
    },
    // 获取下拉列表数据
    getDropdownListData () {
      // 获取收款比例不超过100%的销售合同列表数据
      getContractsSellPercentage({ paging: false }).then(res => {
        this.contractList = res.data
      })
      // 获取收款类型数据
      // getDictInfoByCode({ pCode: 'PAYMENT_TYPE' }).then(res => {
      //   this.paymentTypeList = res.data
      // })
      // 获取经办人
      getHandlerList().then(res => {
        this.operatorList = res.data
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          this.form.validateFieldsAndScroll((err, value) => {
            if (!err) {
              var params = { ...value }
              if (this.type === this.$sysInfo.MODAL_MODIFY) {
                params.id = this.model.id
              }
              // 付款公司id
              params.companyId = this.companyId
              // 合同名称
              params.contractName = this.contractName
              // 经办人姓名
              params.operatorName = this.operatorName
              // 时间
              params.payTime = moment(params.payTime).format('YYYY-MM-DD')
              // 关联开票
              if (params.paymentInvoiceList) {
                params.paymentInvoiceList = params.paymentInvoiceList.map(item => {
                  return { invoiceId: item }
                })
              }
              params.type = 2
              // return
              controlCollection(params).then(res => {
                if (res.status === 0) {
                  this.$message.success(res.info.message)
                  this.$emit('refreshTable')
                  this.cancel()
                } else {
                  this.$message.error(res.info.message)
                }
              })
            }
          })
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      const data = {
        id: this.model.id
      }
      getControlCollectionDetail(data).then(res => {
        if (res.status === 0) {
          this.$nextTick(() => {
            // 获取收款列表
            this.getInvoiceList(res.data.contractId)
            const index = this.contractList.findIndex(item => item.id === res.data.contractId)
            this.paymentTypeList = this.contractList[index].contractSalePaymentList
            let paymentInvoiceList = []
            if (res.data.invoiceState) {
              if (res.data.paymentInvoiceList.length > 0) {
                paymentInvoiceList = res.data.paymentInvoiceList.map(item => {
                  return item.invoiceId
                })
              }
              this.invoiceShow = true
            } else {
              this.invoiceShow = false
            }
            this.form.setFieldsValue({
              contractId: res.data.contractId,
              contractMoney: res.data.contractMoney,
              operatorId: res.data.operatorId,
              payType: res.data.payType,
              companyName: res.data.companyName,
              payMoney: res.data.payMoney,
              payTime: res.data.payTime ? moment(res.data.payTime).format('YYYY-MM-DD') : undefined,
              invoiceState: res.data.invoiceState,
              paymentInvoiceList: paymentInvoiceList
            })
          })
          this.invoiceState = res.data.invoiceState
          // 合同名称
          this.contractName = res.data.contractName
          // 付款公司id
          this.companyId = res.data.companyId
          // 经办人姓名
          this.operatorName = res.data.operatorName
        } else {
          this.$message.error('获取开票详情失败！')
        }
      })
    },
    // 获取关联开票
    getInvoiceList (id) {
      this.invoiceList = []
      getInvoiceList({ paging: false, type: 2, contractId: id }).then(res => {
        res.data.forEach(item => {
          this.invoiceList.push({
            id: item.id,
            invoiceNo: item.invoiceNo,
            invoiceMoney: item.invoiceMoney
          })
        })
      })
    },
    // 合同变更
    contractChange (id) {
      const index = this.contractList.findIndex(item => item.id === id)
      this.form.setFieldsValue({
        // 付款公司
        companyName: this.contractList[index].partyName,
        // 合同金额
        contractMoney: this.contractList[index].contractAmount,
        // 经办人Id
        operatorId: this.contractList[index].operatorId
      })
      // 付款公司id
      this.companyId = this.contractList[index].partyId
      // 合同名称
      this.contractName = this.contractList[index].name
      // 经办人姓名
      this.operatorName = this.contractList[index].operatorName
      // 获取关联开票
      this.getInvoiceList(id)
      // 给收款类型赋值
      this.paymentTypeList = this.contractList[index].contractSalePaymentList
    },
    // 经办人变更
    operatorIdChange (id) {
      const index = this.operatorList.findIndex(item => item.id === id)
      // 经办人姓名
      this.operatorName = this.operatorList[index].userName
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
      this.able = false
      this.model = {}
      // 开票列表
      this.invoiceList = []
      // 收款类型下拉
      this.paymentTypeList = []
      // 合同名称
      this.contractName = ''
      // 经办人姓名
      this.operatorName = ''
      // 付款公司id
      this.companyId = ''
      // 是否显示关联收款
      this.invoiceShow = true
      // 是否已开票
      this.invoiceState = true
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 是否已开票改变判断
    changePayState (val) {
      this.invoiceState = val
      // 如果是则显示关联收款
      if (val) {
        this.invoiceShow = true
      } else {
        this.invoiceShow = false
      }
    }
  }
}
</script>
<style lang="less">
</style>
